
//var baseAPIURL = 'http://127.0.0.1:5001/blizo-70335/us-central1/blizoapi/';
var baseAPIURL = 'https://api.blizo.co/';
var uploadAPIURL = 'https://upload.blizo.co/';
var downloadAPIURL = 'https://download.blizo.co/';



export { baseAPIURL,uploadAPIURL,downloadAPIURL };